import DOMPurify from 'dompurify';

export const PRODUCT_DESCRIPTION_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'em', 'u', 's', 'b', 'i', 'ul', 'ol', 'li',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'span', 'div', 'blockquote',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style'],
};

export function sanitizeProductDescription(html) {
  if (!html || typeof html !== 'string') return '';
  return DOMPurify.sanitize(html, PRODUCT_DESCRIPTION_CONFIG);
}
